export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $searchbtn = document.querySelector('.btn-searchbox');

        if (!$searchbtn) {
            return;
        }

        const $searchwrapper = document.querySelector('.search-wrapper');
        const $searchboxinput = document.querySelector('.input-searchbox');

        if (!$searchwrapper || !$searchboxinput) {
            return;
        }

        $searchbtn.addEventListener('click', (event) => {
            if ($searchboxinput.value.length === 0) {
                event.preventDefault();
                $searchboxinput.classList.toggle('active');
                $searchwrapper.classList.toggle('toggled');
            }
        });
    });
}
